import styled from "styled-components";
import {
  height,
  HeightProps,
  width,
  WidthProps,
  border,
  BorderProps,
  space,
  SpaceProps,
} from "styled-system";

type HorizontalRuleProps = HeightProps & WidthProps & BorderProps & SpaceProps;

export const HorizontalRule = styled.hr<HorizontalRuleProps>(
  height,
  width,
  border,
  space,
  (props) => ({
    borderColor: props.theme.colors.black,
  }),
  {
    width: "100%",
    height: "1px",
    borderWidth: "0px 0px 1px 0px",
  }
);
